import { useCallback } from 'react';
import { useTrackEvent } from '$analytics/useTrackAnalytics/useTrackAnalytics';

import {
  ContactSyncEventLabels,
  ContactSyncEventsMap,
  type TrackContactSyncEvents,
} from './events';

export function useTrackContactSyncAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackContactSyncEvents, extra?: Record<string, unknown>) => {
      const eventLabel = ContactSyncEventLabels[event];
      const eventInfo = ContactSyncEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
